import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import { loader, toastr } from '../CommonActions'
import { auth } from '../../../services/auth.service';

export const GET_SUBSCRIPTIONS = 'GET_SUBSCRIPTIONS';
export const ADD_SUBSCRIPTION = 'ADD_SUBSCRIPTION';
export const CREATE_SUBSCRIPTION = 'CREATE_SUBSCRIPTION';
export const UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION';
export const GET_SUBSCRIPTION_PACKAGES = 'GET_SUBSCRIPTION_PACKAGES';

const successColor =  "success";
const errorColor = "danger";
const warningColor = "warning";

export function fetchSubscriptions() {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.get(`${ROOT_API_URL}/ManageMagazineSubscriptions/GetMagazineSubscriptions`, { headers: auth.authHeader() })
			.then((response) => {
				dispatch({
					type: GET_SUBSCRIPTIONS,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((error) => {
				var err = "Network Connection Error";
				dispatch(loader(false));
				dispatch(toastr(true,err, errorColor));
			});
	};
}

export function fetchSubscriptionsForAdminGrid() {
    return function (dispatch) {
        dispatch(loader(true));
        axios
			.get(`${ROOT_API_URL}/ManageMagazineSubscriptions/GetMagazineSubscriptionsForAdminGrid`, { headers: auth.authHeader() })
            .then((response) => {
                dispatch({
                    type: GET_SUBSCRIPTIONS,
                    payload: response.data
                });
                dispatch(loader(false));
            })
            .catch((error) => {
                var err = "Network Connection Error";
                dispatch(loader(false));
                dispatch(toastr(true, err, errorColor));
            });
    };
}

export function fetchSubscriptionPackages() {
    return function (dispatch) {
        dispatch(loader(true));
        axios
			.get(`${ROOT_API_URL}/ManageMagazineSubscriptions/GetMagazineSubscriptionPackages`, { headers: auth.authHeader() })
            .then((response) => {
                dispatch({
                    type: GET_SUBSCRIPTION_PACKAGES,
                    payload: response.data
                });
                dispatch(loader(false));
            })
            .catch((error) => {
                var err = "Network Connection Error";
                dispatch(loader(false));
                dispatch(toastr(true, err, errorColor));
            });
    };
}

export function addSubscription(model) {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageMagazineSubscriptions/AddMagazineSubscription`, model, { headers: auth.authHeader() })
			.then(function(response) {
				if (response && response.data && response.data.issuccess) {
					dispatch({
						type: ADD_SUBSCRIPTION,
						payload: response.data.magazineSubscriptions
					});
					var success = response && response.data ? response.data.message : 'Subscription Created Successfully';
					dispatch(toastr(true, success, successColor));
				}
				else {
					var err = response && "Error Creating Subscription";
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function createSubscription(model) {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageMagazineSubscriptions/CreateMagazineSubscription`, model, { headers: auth.authHeader() })
			.then(function(response) {
				if (response && response.data && response.data.issuccess) {
					dispatch({
						type: CREATE_SUBSCRIPTION,
						payload: response.data.magazineSubscriptions
					});
					var success = response && response.data ? response.data.message : 'Subscription Created Successfully';
					dispatch(toastr(true, success, successColor));
				}
				else {
					var err = response && "Error Creating Subscription";
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function updateSubscription(model) {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageMagazineSubscriptions/UpdateMagazineSubscription`, model, { headers: auth.authHeader() })
			.then((response) => {
				if (response && response.data && response.data.issuccess)
				{
					dispatch({
						type: UPDATE_SUBSCRIPTION,
						payload: response.data.magazineSubscriptions
					});
					var success = response && response.data ? response.data.message : "Subscription Updated Successfully";
					dispatch(toastr(true,success, successColor));
				}
				else {
					var err = response && "Error Updating Subscription";
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}
